import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetEnrolledPatientsArgs } from "../schemas";

const getEnrolledPatientsQueryKey = (args: GetEnrolledPatientsArgs) =>
  ["getEnrolledPatients", args.health_care_organization_id, args.params] as const;

export const useGetEnrolledPatients = (args: GetEnrolledPatientsArgs) => {
  const client = useApiClient();

  return useQuery(getEnrolledPatientsQueryKey(args), () => client.getEnrolledPatients(args));
};
